export default __webpack_public_path__ + "static/media/Cang-Jei's Smile.d836d7bf.jpg";